// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"dea625eb","903":"06e8662c","963":"845a58d9"}[chunkId] + ".chunk.js";
};